import {
  type FavoriteWorkplacesResponse,
  favoriteWorkplacesResponseSchema,
  type GetFavoriteWorkplacesRequest,
  getFavoriteWorkplacesRequestSchema,
} from "@clipboard-health/contract-worker-app-bff";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";

export const FAVORITE_WORKPLACES_URL = `${environmentConfig.REACT_APP_WORKER_APP_BFF_URL}/favorite-workplaces`;

const DEFAULT_INCLUDE = ["workplace"];

export function getFavoriteWorkplacesBaseQueryKey() {
  return [FAVORITE_WORKPLACES_URL];
}

function constructQueryParams(params: GetFavoriteWorkplacesRequest) {
  return {
    ...params,
    include: params.include ?? DEFAULT_INCLUDE,
  };
}

export type GetFavoriteWorkplacesIncludedWorkplace = Exclude<
  FavoriteWorkplacesResponse["included"],
  undefined
>[number];

export function getFavoriteWorkplacesQueryKey(params: {
  queryParams: GetFavoriteWorkplacesRequest;
}) {
  const { queryParams } = params;
  return [FAVORITE_WORKPLACES_URL, constructQueryParams(queryParams)];
}

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface UseGetFavoriteWorkplacesOptions
  extends UseGetQueryOptions<FavoriteWorkplacesResponse> {}

const TIME_UNTIL_STALE_OR_GARBAGE_COLLECTED = 1000 * 60 * 5;
export function useGetFavoriteWorkplaces(
  params: GetFavoriteWorkplacesRequest,
  options: UseGetFavoriteWorkplacesOptions = {}
) {
  return useGetQuery({
    url: FAVORITE_WORKPLACES_URL,
    queryParams: constructQueryParams(params),
    requestSchema: getFavoriteWorkplacesRequestSchema,
    responseSchema: favoriteWorkplacesResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_FAVORITE_WORKPLACES_FAILURE,
    },
    staleTime: TIME_UNTIL_STALE_OR_GARBAGE_COLLECTED,
    cacheTime: TIME_UNTIL_STALE_OR_GARBAGE_COLLECTED,
    ...options,
  });
}
